import { SkeletonBodyText, SkeletonDisplayText } from '@shopify/polaris';
import { Table } from 'antd';
import React from 'react';

export const ArchievedOrderSkeleton = () => {
    const columns = [
        {
            title: 'Order Id',
            dataIndex: 'id',
            width: '250px',

        },
        {
            title: 'Date',
            dataIndex: 'date',
            width: '250px',
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            width: '100px',
        }
    ];
    const rows = [
        {
            key: '1',
            id: <SkeletonBodyText lines={1} />,
            date: <SkeletonBodyText lines={1} />,
            actions: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '2',
            id: <SkeletonBodyText lines={1} />,
            date: <SkeletonBodyText lines={1} />,
            actions: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '3',
            id: <SkeletonBodyText lines={1} />,
            date: <SkeletonBodyText lines={1} />,
            actions: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '4',
            id: <SkeletonBodyText lines={1} />,
            date: <SkeletonBodyText lines={1} />,
            actions: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '5',
            id: <SkeletonBodyText lines={1} />,
            date: <SkeletonBodyText lines={1} />,
            actions: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '6',
            id: <SkeletonBodyText lines={1} />,
            date: <SkeletonBodyText lines={1} />,
            actions: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '7',
            id: <SkeletonBodyText lines={1} />,
            date: <SkeletonBodyText lines={1} />,
            actions: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '8',
            id: <SkeletonBodyText lines={1} />,
            date: <SkeletonBodyText lines={1} />,
            actions: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '9',
            id: <SkeletonBodyText lines={1} />,
            date: <SkeletonBodyText lines={1} />,
            actions: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '10',
            id: <SkeletonBodyText lines={1} />,
            date: <SkeletonBodyText lines={1} />,
            actions: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '11',
            id: <SkeletonBodyText lines={1} />,
            date: <SkeletonBodyText lines={1} />,
            actions: <SkeletonDisplayText size="medium" />,
        },

    ];

    return <Table columns={columns} dataSource={rows} scroll={{ x: 600, }} pagination={false} size='middle' />;
}


export const FailedOrderSkeleton = () => {
    const columns = [
        {
            title: 'Amazon Order Id',
            dataIndex: 'id',
            width: '272px',
        },
        {
            title: 'App Status',
            dataIndex: 'amazonStatus',
            width: '218px',
        },
        {
            title: 'Failure Reason',
            dataIndex: 'reason',
            width: '704px',
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            width: '256px',
        }
    ];
    const rows = [
        {
            key: '1',
            id: <SkeletonBodyText lines={1} />,
            amazonStatus: <SkeletonBodyText lines={1} />,
            reason: <SkeletonBodyText lines={4} />,
            actions: <div style={{width: '185px'}}><SkeletonDisplayText size="medium" /></div>,
        },
        {
            key: '2',
            id: <SkeletonBodyText lines={1} />,
            amazonStatus: <SkeletonBodyText lines={1} />,
            reason: <SkeletonBodyText lines={4} />,
            actions: <div style={{width: '185px'}}><SkeletonDisplayText size="medium" /></div>,
        },
        {
            key: '3',
            id: <SkeletonBodyText lines={1} />,
            amazonStatus: <SkeletonBodyText lines={1} />,
            reason: <SkeletonBodyText lines={4} />,
            actions: <div style={{width: '185px'}}><SkeletonDisplayText size="medium" /></div>,
        },
        {
            key: '4',
            id: <SkeletonBodyText lines={1} />,
            amazonStatus: <SkeletonBodyText lines={1} />,
            reason: <SkeletonBodyText lines={4} />,
            actions: <div style={{width: '185px'}}><SkeletonDisplayText size="medium" /></div>,
        },
        {
            key: '5',
            id: <SkeletonBodyText lines={1} />,
            amazonStatus: <SkeletonBodyText lines={1} />,
            reason: <SkeletonBodyText lines={4} />,
            actions: <div style={{width: '185px'}}><SkeletonDisplayText size="medium" /></div>,
        },
        {
            key: '6',
            id: <SkeletonBodyText lines={1} />,
            amazonStatus: <SkeletonBodyText lines={1} />,
            reason: <SkeletonBodyText lines={4} />,
            actions: <div style={{width: '185px'}}><SkeletonDisplayText size="medium" /></div>,
        },
        {
            key: '7',
            id: <SkeletonBodyText lines={1} />,
            amazonStatus: <SkeletonBodyText lines={1} />,
            reason: <SkeletonBodyText lines={4} />,
            actions: <div style={{width: '185px'}}><SkeletonDisplayText size="medium" /></div>,
        },
        {
            key: '8',
            id: <SkeletonBodyText lines={1} />,
            amazonStatus: <SkeletonBodyText lines={1} />,
            reason: <SkeletonBodyText lines={2} />,
            actions: <div style={{width: '185px'}}><SkeletonDisplayText size="medium" /></div>,
        },
    ];

    return <Table columns={columns} dataSource={rows} scroll={{ x: 1200, }} pagination={false} size='middle' rowSelection={{}}/>;
}